<script setup lang="ts">

import { useCoreStore } from '@/stores/core/store'
import { 
  supportingText,
  socialMedia,
  newsletter,
  navigationMenus,
  copyright,
  selectOptions,
  locale
 } from './footer-data'

import { Footer } from '@easybell/caramel-vue3'

const coreStore = useCoreStore()

</script>

<template>
  <Footer
  class="footer"
  :supporting-text="supportingText"
  :social-media="socialMedia"
  :newsletter="newsletter"
  :copyright="copyright"
  :navigation-menus="navigationMenus"
  :locale="locale"
  :select-options="selectOptions"
  @set-locale="coreStore.changeLanguage($event)"
/>
</template>
